// 流程对话框 数据

const processDlg = {
  namespaced: true,

  state: {
    dlgType: '',

    operateType: '',

    formData: {},

    processData: {},
  },

  getters: {
    dlgType: state => state.dlgType,

    operateType: state => state.operateType,

    formData: state => state.formData,

    processData: state => state.processData
  },

  mutations: {
    SET_DLGTYPE: (state, val) => {
      state.dlgType = val
    },

    SET_OPERATETYPE: (state, val) => {
      state.operateType = val
    },

    SET_FORMDATA: (state, val) => {
      state.formData = val
    },

    SET_PROCESSDATA: (state, val) => {
      state.processData = val
    },
  },

  actions: {

  }
}

export default processDlg
